module.exports = __webpack_public_path__ + "static/smart_shoe-4fa2de00da73a2cf1a214b1839ebc7fd.jpg";